// Times in words, as Talk and the inbox show them (shared by the web and the app).
/** A message's time: "3:04 PM" today, "2h ago" within six hours, else "Nov 3" (with the year when it isn't this one). */
export function when(iso) {
    const d = new Date(iso), now = new Date();
    if (d.toDateString() === now.toDateString())
        return d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
    const mins = (now.getTime() - d.getTime()) / 60000;
    if (mins < 6 * 60)
        return `${Math.round(mins / 60)}h ago`;
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", ...(d.getFullYear() === now.getFullYear() ? {} : { year: "numeric" }) });
}
export const dayOf = (iso) => new Date(iso).toDateString();
/** A day divider: "Today", "Nov 3", "Dec 30, 2025". */
export const dayLabel = (iso) => {
    const d = new Date(iso), now = new Date();
    if (d.toDateString() === now.toDateString())
        return "Today";
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", ...(d.getFullYear() === now.getFullYear() ? {} : { year: "numeric" }) });
};
//# sourceMappingURL=time.js.map